<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col sm="10">
            <h3>Instituição</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-form v-on:submit.prevent="onSubmit">
          <b-row>
            <b-col sm="4">
              <b-form-group>
                <b-form-group label="Categoria">
                  <b-form-select class="mb-3" v-model="form.categoria" :options="categorias"></b-form-select>
                </b-form-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-form-group label="Nome da Instituição">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="Razão Social da Instituição" v-model="form.nome_instituicao" disabled />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="CNPJ">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="CNPJ" v-model="form.cnpj" disabled />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="E-mail Institucional">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="E-mail Institucional" v-model="form.email_instituicao" disabled />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Telefone">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="Telefone" v-model="form.telefone" disabled />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="6">
              <b-form-group label="Telefone">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="Telefone" v-model="form.telefone" disabled />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <h4><strong>Endereço</strong></h4>
          <hr>

          <b-row>
            <b-col cols="6">
              <b-form-group label="CEP">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="CEP" v-model="form.cep" disabled />
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="UF:">
                <b-form-select v-model="form.uf_id" :options="estados" class="mb-3" disabled>
                  <option selected :value="null"> Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="3">
              <b-form-group label="Município:">
                <b-form-select v-model="form.municipio_id" :options="cidades" disabled>
                  <option selected :value="null"> Selecione</option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Endereço">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="CNPJ" v-model="form.endereco" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Número">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="Número" v-model="form.numero" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label="Complemento">
                <b-input-group class="mb-6">
                  <b-form-input type="text" class="form-control" placeholder="Complemento" v-model="form.complemento" disabled/>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          </br></br>
          <b-row>
            <b-col cols="12">
              <h4><strong>Lista de integrantes</strong></h4>
              <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th scope="col">Nome</th>
                    <th scope="col">CPF</th>
                    <th scope="col">Perfil</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="form.users.length > 0">
                  <tr v-for="user in form.users" :key="user.id">
                    <td>{{user.nome}}</td>
                    <td>{{user.cpf}}</td>
                    <td>{{user.perfil.nome}}</td>
                    <td style="width: 15%">
                      <a class="btn btn-sm btn-secondary action" title="Visualizar" @click="visualizarUsuario(user.id)">
                        <i class="fa fa-search"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="4">Nenhum usuário vínculado</td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="3">
            <b-button block variant="primary" v-on:click="onSubmit">
              <i class="fa fa-check"></i>&nbsp;
              <span>Editar</span>
            </b-button>
          </b-col>
          <b-col md="3">
            <b-button block variant="secondary" @click="$router.go(-1)">
              <i class="fa fa-mail-reply-all"></i>&nbsp;&nbsp;<span>Voltar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </span>
</template>

<script>
import Vue from 'vue'
import AuthTemplate from '@/templates/auth/AuthTemplate'
import VueSelect from 'vue-select'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    AuthTemplate,
    VueSelect
  },
  created () {
    this.$store.dispatch('buscarEstados')

    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'A') {
      this.$router.push('/')
    }
  },
  data () {
    return {
      form: {
        id: null,
        categoria: null,
        nome_instituicao: null,
        email_instituicao: null,
        cnpj: null,
        matricula: null,
        uf_id: null,
        municipio_id: null,
        telefone: null,
        dependencia_administrativa: null,
        cep: null,
        endereco: null,
        complemento: null,
        numero: null,
        codigo_externo: null,
        users: []
      },
      categorias: [
        {text: 'OSC', value: 'OC'},
        {text: 'Prefeitura Municipal', value: 'PF'},
        {text: 'Governo do Estado', value: 'GE'}
      ],
      editorConfig: {
        removePlugins: 'elementspath,resize,codesnippet'
      }
    }
  },
  mounted () {
    if (typeof this.$route.params.id !== 'undefined') {
      this.loadInstituicao(this.$route.params.id)
    }
  },
  watch: {
    'form.uf_id': function () {
      if (this.form.uf_id !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.form.uf_id)
      } else {
        this.form.uf_id = null
      }
    }
  },
  computed: {
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    },
    isValid () {
      return !this.$v.form.$anyError
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    loadInstituicao (id) {
      Vue.http.get('api/instituicao/' + id).then((response) => {
        this.form.id = response.body.data.id
        this.form.categoria = response.body.data.categoria
        this.form.nome_instituicao = response.body.data.nome_instituicao
        this.form.email_instituicao = response.body.data.email_instituicao
        this.form.cnpj = response.body.data.cnpj
        this.form.matricula = response.body.data.matricula
        this.form.uf_id = response.body.data.municipio.estado_id
        this.form.municipio_id = response.body.data.municipio_id
        this.form.telefone = response.body.data.telefone
        this.form.dependencia_administrativa = response.body.data.dependencia_administrativa
        this.form.cep = response.body.data.cep
        this.form.endereco = response.body.data.endereco
        this.form.complemento = response.body.data.complemento
        this.form.numero = response.body.data.numero
        this.form.codigo_externo = response.body.data.codigo_externo
        
        this.form.users = response.body.data.users
      })
    },
    onSubmit () {
      this.confirmar()
    },
    confirmar () {
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja continuar?', {
          okTitle: 'Confirmar',
          cancelTitle: 'Cancelar'
        })
        .then((valor) => {
          if (valor) {
            this.salvar()
          }
        })
        .catch((erro) => {
          console.log(erro)
        })
    },
    salvar () {
      let form = this.form
      console.log(form.categoria)
      if(form.categoria == null) {
        miniToastr.setIcon('danger', 'i', { class: 'fa fa-check' })
        miniToastr.error('Informe a categoria!', 'Alerta!', 7000)
        return false
      }

      let data = {
        id: this.id,
        categoria: form.categoria
      }

      Vue.http
        .put('api/instituicao/' + form.id, data)
        .then((response) => {
          if (response.body.success) {
            miniToastr.setIcon('success', 'i', { class: 'fa fa-check' })
            miniToastr.success(response.body.msg, 'Sucesso!', 7000)
            this.$router.push({ path: '/instituicao' })
          } else {
            miniToastr.setIcon('error', 'i', { class: 'fa fa-warning' })
            miniToastr.error(response.body.msg, 'Alerta', 5000)
          }
        })
        .catch((e) => {
          console.log('Servidor está fora! ' + e)
        })
    },
    visualizarUsuario (id) {
      this.$router.push('/usuario/' + id + '/visualizar')
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
img.preview {
  width: 200px;
  background-color: white;
  border: 1px solid #ddd;
  padding: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/instituicao/InstituicaoForm.vue